import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sick-leave-confirmation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sick-leave-confirmation.component.html',
  styleUrls: ['./sick-leave-confirmation.component.css']
})
export class SickLeaveConfirmationComponent implements OnInit {
  isError = false;
  errorMessage = '';
  successMessage = '';

  constructor(
      private router: Router,
      private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // Check for error or success parameters in the route
    this.route.queryParams.subscribe(params => {
      if (params['error']) {
        this.isError = true;
        this.errorMessage = params['message'] || 'Ein Fehler ist aufgetreten beim Erstellen der Krankmeldung.';
      } else {
        this.isError = false;
        this.successMessage = params['message'] || 'Die Krankmeldung wurde erfolgreich im System gespeichert.';
      }
    });
  }

  onNewEntry() {
    this.router.navigate(['/sick-leave']);
  }

  onBackToHome() {
    this.router.navigate(['/']);
  }

  onRetry() {
    this.router.navigate(['/sick-leave']);
  }
}